"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _entry = require("react-pdf/dist/esm/entry.webpack");

var _core = require("@material-ui/core");

var _reactReduxI18n = require("react-redux-i18n");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Button = _interopRequireDefault(require("../Button"));

var _jsxRuntime = require("react/jsx-runtime");

var LoadingBlock = function LoadingBlock() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "d-flex align-items-center justify-content-center information-primary",
    style: {
      height: 400,
      width: 280
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      icon: "loader",
      size: 25
    })
  });
};

function UploadDocumentDetails(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      fileUrl = _useState2[0],
      setFileUrl = _useState2[1];

  function getFileSize() {
    return "".concat(Math.round(props.file.size / 1000), " Kb");
  }

  function displayLoadingMessage() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "loading-overlay"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          zIndex: 100
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: "document.uploadAIAnalysis.inProgress"
        })
      })]
    });
  }

  function displayDocumentDetails() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "d-flex flex-column flex-grow-1 ml-4",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.filename"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "mb-5",
          children: props.file.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "document.fileSize"
          })
        }), getFileSize()]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "align-self-end d-flex align-items-center",
        style: {
          marginTop: 'auto'
        },
        children: [fileUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "mr-5",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Link, {
            href: fileUrl,
            target: "_blank",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "flex-container",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                icon: "new-tab"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                value: "document.checkFile"
              })]
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          onClick: props.onRemoveFile,
          icon: "redo",
          children: _reactReduxI18n.I18n.t('document.changeFile')
        })]
      })]
    });
  }

  (0, _react.useEffect)(function () {
    if (props.file.type === 'application/pdf') {
      setFileUrl(URL.createObjectURL(props.file));
    }

    return function () {
      // Revoke the data uri to avoid memory leaks
      URL.revokeObjectURL(fileUrl);
    };
  }, [props.file.name]);
  var className = 'box d-flex mb-5';

  if (props.loadingApi) {
    className += ' align-items-center justify-content-center';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: className,
    children: [props.loadingApi && displayLoadingMessage(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Paper, {
      style: {
        opacity: props.loadingApi ? 0.4 : 1
      },
      children: fileUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_entry.Document, {
        file: fileUrl,
        loading: /*#__PURE__*/(0, _jsxRuntime.jsx)(LoadingBlock, {}),
        className: "d-flex align-items-center justify-content-center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_entry.Page, {
          pageNumber: 1,
          className: "d-flex align-items-center justify-content-center",
          width: 310,
          loading: /*#__PURE__*/(0, _jsxRuntime.jsx)(LoadingBlock, {}),
          renderAnnotationLayer: false
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "d-flex align-items-center justify-content-center information-primary",
        style: {
          height: 150,
          width: 150
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
          icon: "document",
          size: 40
        })
      })
    }), !props.loadingApi && displayDocumentDetails()]
  });
}

UploadDocumentDetails.propTypes = {
  file: _propTypes.default.object.isRequired,
  onRemoveFile: _propTypes.default.func.isRequired,
  loadingApi: _propTypes.default.bool.isRequired
};
var _default = UploadDocumentDetails;
exports.default = _default;
//# sourceMappingURL=UploadDocumentDetails.js.map